export default "__VITE_ASSET__BQEoLwrJ__"